<template>
  <div class="card">
    <div class="card-body">
      <form @submit.prevent="onSubmit">
        <div class="form-group row mb-4">
          <label for="api-consumers-title" class="col-form-label col-lg-2">
            Name
          </label>
          <div class="col-lg-6">
            <b-form-group>
              <b-form-input
                id="api-consumers-name"
                name="api-consumers-name"
                type="text"
                v-model="$v.apiConsumers.name.$model"
                :state="validateField('name')"
              ></b-form-input>
              <b-form-invalid-feedback class="col-lg-6">
                {{ $t("validation.required") }}
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
        </div>
        <div class="row justify-content-end">
          <div class="col-12">
            <button type="submit" class="btn btn-primary m-2">
              <i class="fa fa-building" aria-hidden="true"></i>
              Speichern
            </button>
            <button @click="$router.go(-1)" type="button" class="btn btn-secondary m-2">
              <i class="fa fa-arrow-left" aria-hidden="true"></i>
              {{ $t("go-back") }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n";
import { required } from "vuelidate/lib/validators";
import { adminService } from '@/helpers/services/admin/adminService';


export default {
  name: "api-consumer-edit",
  props: {
    apiConsumer: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      title: i18n.t(""), // initialize i18n, as "$t" in template is not enough
      apiConsumers: this.apiConsumer,
      apiAccess: {
        isActive: false,
        name: null
      },
      allTenants: [],
    }
  },
  methods: {
    validateField(name) {
      const { $dirty, $error } = this.$v.apiConsumers[name];
      return $dirty ? !$error : null;
    },
    onSubmit() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      adminService.addNewApiConsumer(this.apiConsumers);
    }
  },
  validations: {
    apiConsumers: {
      name: { required, },
    }
  },
  created() {
    adminService.fetchAllSubscriptions()
    .then(as => this.allSubscriptions = as);
  }
}
</script>

<style>

</style>